<template>
  <div>
    <splash-lottie
      :cityCode="divisionInfo.cityCode"
      @aniComplete="aniComplete"></splash-lottie>
    <div :class="{'isOverhidden': isBehind}">
      <system-fail v-if="showSystemFail" @retry="init">
      </system-fail>
      <div v-else class="lottery">
        <div class="lottery-img">
          <header-lottie></header-lottie>
          <div class="lottery-ruler" @click="toRuler"></div>
          <div class="lottery-guide" @click="toGuide"></div>
          <div :class="['lottery-music', {'lottery-music-close':!musicIsPlay}]" @click="handleMusic">
            <audio ref="audioObj" v-if="showMusic">
              <source src="https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/hct-music-1229.mp3">
            </audio>
          </div>
          <div class="lottery-title">团圆好彩头</div>
          <div class="lottery-message">数字人民币新春献礼！100%可抽中！</div>
          <title-bar
            :title-bar-info="titleBarInfo"
            :scrolling-title-bar-info="scrollingTitleBarInfo"
            @back="closePage"
          >
            <div slot="titleBarMiddle" class="logo-container">
              <img class="logo-img" src="https://p0.meituan.net/wxapp/2249e66ab325c915b17e5755fc2f8ad67169.png" />
              <img class="logo-img" src="https://p0.meituan.net/wxapp/2249e66ab325c915b17e5755fc2f8ad67169.png" />
            </div>
            <div slot="titleBarRight" class="manage-titleBar">
              <div class="share-icon" @click="shareActivity"></div>
            </div>
            <div slot="scrollingTitleBarRight" class="scrolling-titleBar">
              <div class="share-icon" @click="shareActivity"></div>
            </div>
          </title-bar>
          <lottery-proxy
            v-if="status==='SUCCESS'"
            :lotteryCount="lotteryCount"
            :shareStatus="shareStatus"
            :hctUserRewardInfoBOS="hctUserRewardInfoBOS"
            :portraitStatus="portraitStatus"
            :appPortrait="appPortrait"
            :cityCode="divisionInfo.cityCode"
            :bankIdStr="bankIdStr"
            :lotteryStatus="lotteryStatus"
            @refresh="init"
          >
          </lottery-proxy>
          <lottery-fail
            v-if="status==='FAIL'"
            :failMessage="failMessage"
          ></lottery-fail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import lottie from 'lottie-web';
import SystemFail from '@/components/SystemFail.vue';
import TitleBar from '@/components/TitleBar.vue';
import { api } from '@/common/api';
import { monitor } from '@/common/monitor';
import { shareH5 } from '@/tools/shareUtils';
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import { lxConfig } from '@/analytic/profilePhoto';
import { lotteryActivityId } from '@/common/config';
import LotteryProxy from './views/LotteryProxy.vue';
import LotteryFail from './views/LotteryFail.vue';
import SplashLottie from './components/SplashLottie.vue';
import HeaderLottie from './components/HeaderLottie.vue';

export default {
  components: {
    LotteryProxy,
    LotteryFail,
    SystemFail,
    TitleBar,
    SplashLottie,
    HeaderLottie
  },
  data() {
    return {
      divisionInfo: {},
      lotteryCount: '',
      shareStatus: false,
      lotteryStatus: false,
      portraitStatus: false,
      hctUserRewardInfoBOS: [],
      appPortrait: '',
      status: '',
      failMessage: {},
      showSystemFail: false,
      titleBarInfo: {
        title: '',
        backgroundColor: 'transparent'
      },
      scrollingTitleBarInfo: {
        title: '团圆好彩头',
        backgroundColor: '#fff',
        backIcon:
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.ecny.hardwarewallet-files/leftArrow-20220811.png',
        titleColor: 'rgba(0,0,0,0.90)',
      },
      musicIsPlay: false,
      isBehind: true,
      showMusic: true // 解决iOS跳出页面再返回时，无法播放音乐的问题
    };
  },
  async created() {
    await this.init();
  },
  mounted() {
    this.$bridge.subscribe('disappear', () => {
      this.$refs.audioObj.pause();
      this.musicIsPlay = false;
      this.showMusic = false;
    });
    this.$bridge.subscribe('background', () => {
      this.$refs.audioObj.pause();
      this.musicIsPlay = false;
    });
    this.$bridge.subscribe('foreground', () => {
      this.init();
    });
    this.$bridge.subscribe('appear', () => {
      this.init();
      this.showMusic = true;
      this.$nextTick(() => {
        this.$refs.audioObj && this.$refs.audioObj.addEventListener('ended', this.closeMusicIcon);
      });
    });
    this.$refs.audioObj && this.$refs.audioObj.addEventListener('ended', this.closeMusicIcon);
  },
  computed: {
    bankIdStr() {
      if (!Array.isArray(this.hctUserRewardInfoBOS)) {
        return '';
      }
      const bankList = [];
      this.hctUserRewardInfoBOS.forEach((item) => {
        bankList.push(item.bankTypeId);
      });
      return bankList.join();
    }
  },
  methods: {
    async init() {
      try {
        if (!env.isInMeituan && !env.isInWaimai) {
          this.status = 'FAIL';
          this.failMessage = {
            message: '仅支持在美团/美团外卖App内访问',
            btnText: '去访问'
          };
          return;
        }
        // 判断是否登陆
        const userInfo = await this.$bridge.getUserInfo();
        if (!userInfo || (userInfo.userId < 0)) {
          this.status = 'FAIL';
          this.failMessage = {
            message: '活动仅限登录用户参与，请先登录您的美团账号'
          };
          this.$bridge.login();
          return;
        }
        // 获取定位
        let location = env.isInWaimai ? '0_0' : env.commonParams.location;
        // 外卖的lat和lng是首页选择的地址
        try {
          if (location === '0_0' || location === '0.0_0.0') {
            await this.$bridge.checkLocationService();
            const _res = await this.$bridge.getLocation();
            let lat = _res && _res.lat;
            let lng = _res && _res.lng;
            if (typeof (lat) === 'undefined' || typeof (lng) === 'undefined') {
              monitor.captureMessage(
                {
                  name: '【好彩头-定位信息为空】',
                  msg: JSON.stringify(_res)
                },
                {
                  level: 'warn'
                }
              );
              lat = '0';
              lng = '0';
            }
            location = `${lat}_${lng}`;
          }
        } catch (err) {
          this.status = 'FAIL';
          this.failMessage = {
            message: '抱歉，当前活动仅限数字人民币试点城市参与。如您已在试点城市，请尝试打开手机定位权限或稍后再试。',
            btnText: '查看活动规则',
            errorCode: 400006,
            url: 'https://cube.meituan.com/cube/block/5ddd27f0e8f1/211528/index.html'
          };
          monitor.captureMessage(
            {
              name: '【好彩头-获取定位失败】',
              msg: JSON.stringify(err)
            },
            {
              level: 'warn'
            }
          );
          return;
        }
        this.showSystemFail = false;
        const res = await api.queryHctActivityHome(location);
        if (!res) {
          throw Error('res为空');
        }
        this.status = res.status || '';
        this.divisionInfo = res.divisionInfo || {};
        this.lotteryCount = res.lotteryCount || '';
        this.lotteryStatus = res.lotteryStatus;
        this.shareStatus = res.shareStatus || false;
        this.portraitStatus = res.portraitStatus || false;
        this.hctUserRewardInfoBOS = res.hctUserRewardInfoBOS || [];
        this.appPortrait = res.appPortrait || '';
        this.failMessage = res.failMessage || {};
      } catch (err) {
        this.showSystemFail = true;
        monitor.captureMessage({
          name: '【好彩头-首页接口异常】',
          msg: JSON.stringify(err)
        }, {
          level: 'error'
        });
      }
    },
    toRuler() {
      lx.addTag({
        c_fsp_dcep_j4pmca31: {
          bid: lxConfig.activity_ruler_btn_mc,
          from: env.from || -999,
          activity_id: env.actGroupName || lotteryActivityId,
          bank_id: this.bankIdStr,
          city_id: (this.divisionInfo && this.divisionInfo.cityCode) || -999,
          page_status: this.lotteryCount || -999,
          user_status: this.portraitStatus ? 1 : 0
        }
      });
      this.lxMc(lxConfig.activity_ruler_btn_mc);
      this.$bridge.openPage('https://cube.meituan.com/cube/block/5ddd27f0e8f1/211528/index.html');
    },
    toGuide() {
      lx.addTag({
        c_fsp_dcep_j4pmca31: {
          bid: lxConfig.activity_guide_btn_mc,
          from: env.from || -999,
          activity_id: env.actGroupName || lotteryActivityId,
          bank_id: this.bankIdStr,
          city_id: (this.divisionInfo && this.divisionInfo.cityCode) || -999,
          page_status: this.lotteryCount || -999,
          user_status: this.portraitStatus ? 1 : 0
        }
      });
      this.lxMc(lxConfig.activity_guide_btn_mc);
      this.$bridge.openPage('https://cube.meituan.com/cube/block/47ce7022ad83/211529/index.html');
    },
    handleMusic() {
      this.lxMc(lxConfig.play_music_btn_mc);
      const audio = this.$refs.audioObj;
      if (!audio) {
        return;
      }
      if (audio.paused) {
        audio.play();
        this.musicIsPlay = true;
      } else {
        audio.pause();
        this.musicIsPlay = false;
      }
    },
    closePage() {
      this.$bridge.closePage();
    },
    shareActivity() {
      lx.addTag({
        c_fsp_dcep_j4pmca31: {
          bid: lxConfig.nav_share_btn_mc,
        }
      });
      this.lxMc(lxConfig.nav_share_btn_mc);
      const url = `${location.protocol}//${location.host}/resource/pay-dcep-activity-fe/profilePhotoRewrite/${new Date().getTime()}.html?from=share`;
      // const url = 'https://i.meituan.com/c/MTk1MGViMjQt';
      const title = '@你，快来领数字人民币新春好彩头';
      const desc = '100%必得数字人民币好礼';
      const content = '@你，快来领数字人民币新春好彩头，100%必得数字人民币好礼';
      const icon = 'https://p0.meituan.net/wxapp/6927533d0d5bf3009c711c599a59db9518440.jpg';
      shareH5(title, desc, content, icon, url, () => {});
    },
    lxMc(bid) {
      lx.mc(bid, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        bank_id: this.bankIdStr || -999,
        city_id: (this.divisionInfo && this.divisionInfo.cityCode) || -999,
        page_status: this.lotteryCount || -999,
        user_status: this.portraitStatus ? 1 : 0
      }, {
        cid: lxConfig.index_pv
      });
    },
    aniComplete() {
      this.isBehind = false;
      // 播放音乐
      this.musicIsPlay = true;
      this.$nextTick(() => {
        this.$refs.audioObj && this.$refs.audioObj.play();
        this.$refs.audioObj && (this.$refs.audioObj.volume = 0.5);
      });
    },
    closeMusicIcon() {
      this.musicIsPlay = false;
    }
  },
  destroyed() {
    this.$refs.audioObj && this.$refs.audioObj.removeEventListener('ended', this.closeMusicIcon);
  },
};
</script>

<style scoped lang="less">
@import "../../styles/fn.less";
@import "../../styles/base.less";
.isOverhidden {
  overflow: hidden;
}
.lottery {
  position: relative;
  .bg-image-auto('https://p0.meituan.net/wxapp/4160e7fd78863c907eb1ad7fa57a097a722058.png');
  background-color: #ED3850;
  min-height: 100vh;
  .lottery-img {
    .calc-top(margin-top, 0px);
    width: 100%;
    height: 100%;
    display:inline-block;
    position: relative;
    .ani-ball, .ani-fireworks {
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
  }
  .lottery-ruler {
    width: 0.48rem;
    height: 0.9rem;
    position: absolute;
    .bg-image-auto('https://p1.meituan.net/wxapp/301eb6b98de535bbf91ed4f76a5e0ca64175.png');
    right: 0;
    top: 1.54rem;
  }
  .lottery-guide {
    width: 0.48rem;
    height: 0.9rem;
    position: absolute;
    .bg-image-auto('https://p1.meituan.net/wxapp/95dae43adca25e59adfcba8544da673e4336.png');
    right: 0;
    top: 2.54rem;
  }
  .lottery-music {
    position: absolute;
    .bg-image-auto('https://p0.meituan.net/wxapp/a1cd6c21ee113cffb01db6bc5408a4063406.png');
    width: 0.48rem;
    height: 0.67rem;
    right: 0;
    top: 3.54rem;
  }
  .lottery-music-close {
    .bg-image-auto('https://p0.meituan.net/wxapp/9a01f6e831e96421c131a72f8d7fc1b43480.png');
  }
  .lottery-title {
    padding-top: 0.88rem;
    font-weight: 400;
    font-family: 'MF-YuanHeiNoncommercial-Regular';
    font-size: 0.8rem;
    color: #FFFFFF;
    letter-spacing: 0.15rem;
    margin-left: 0.15rem;
    text-align: center;
    line-height: 1;
  }
  .lottery-message {
    margin: 0.14rem auto auto;
    border-radius: 0.26rem;
    background-image: linear-gradient(to right, rgba(31,127,255,0.3), rgba(160,90,255,0.3));
    width: 4.58rem;
    height: 0.53rem;
    line-height: 0.53rem;
    text-align: center;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #FFFFFF;
  }
}
.logo-container {
  width: 4rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-left: 0.06rem;
  .logo-img {
    height: 0.29rem;
    animation: logo-gradient 10s linear infinite;
    -moz-animation: logo-gradient 10s linear infinite;
    -webkit-animation: logo-gradient 10s linear infinite;
    -o-animation: logo-gradient 10s linear infinite;
  }
}
.manage-titleBar {
  display: flex;
  align-items: center;
  .share-icon {
    width: 48px;
    height: 48px;
    .bg-image-auto('https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/share-icon-white-20221107.png');
  }
}
.scrolling-titleBar {
  display: flex;
  align-items: center;
  .share-icon {
    width: 48px;
    height: 48px;
    .bg-image-auto('https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/share-icon-black-20221107.png');
  }
}
@keyframes logo-gradient {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
